"use strict";

$.widget("fotobook.fontSizeBaseWidget", $.fotobook.containereditorbasecontrol, {
    "options" : {
        "def_size" : 14,
        "min_size" : 1,
        "max_size" : 99,
    },
    input: null,
    _create: function(){
        var widget = this;
        this._createLayout();
        this.input.numberInput({
            "max" : this.options.max_size,
            "min" : this.options.min_size,
            "step" : 1,
            "input" : function(event, fontSize){
                widget._setPreviewStyle(fontSize);
            },
            "change" : function(event, fontSize){
                widget._changeFontSize(fontSize);
            },
            "cancel" : function(event, fontSize){
                widget._removePreviewStyle(fontSize);
            },
        });
        this._super();
    },

    _createLayout: function(){
        this.input = $("<input>", {
            "class" : "font-size-widget",
            "type" : "text",
            "maxlength" : 2,
        });
        this.element.append(this.input);
    },

    _containerChanged: function(){
        this.input.numberInput("value", this._getValueFromProject());
        this._super();
    },

    _getValueFromProject: function(){
        return 0;
    },

    _setPreviewStyle: $.noop,
    _removePreviewStyle: $.noop,
    _changeFontSize: $.noop,

    /**
     * Преобразовывает фонтсайз из номера (в тулбаре) в пиксели
     * @param integer fs_num - номер размера шрифта в тулбаре
     * @return float - размер в пикселях
     */
    _fsNum2Px: function (fs_num) {
        return Fotobook.book.getBaseFontSize() * fs_num / this.options.def_size;
    },
    /**
     * Преобразовывает фонтсайз из пикселей в номер в тулбаре
     * @param float fs_px - размер в пикселях
     * @return integer - размер в пикселях
     */
    _fsPx2Num: function (fs_px) {
        return Math.round(this.options.def_size * parseFloat(fs_px) / Fotobook.book.getBaseFontSize());
    },

    _destroy: function(){
        this._super();
        this.input.remove();
    },
});
